import React from 'react';
import { Button, CheckPicker, SelectPicker, Stack } from 'rsuite';
import {
  fetchColors,
  fetchFinishes,
  fetchHsn,
  fetchMaterials,
  fetchCategory,
  fetchSkuUnique,
  fetchAlias,
  fetchBuyers,
  fetchMadeBy,
  fetchHeads,
  fetchProductLabel,
  fetchProductDesign,
  fetchProductName,
  fetchSearchKeyword,
  fetchProductTypes
} from '../../src/apiService/apiService';
const HeaderFilter = ({
  head,
  label,
  //data states
  categorydata,
  productypedata,
  colordata,
  proNamedata,
  skudata,
  buyernamedata,
  finishdata,
  aliasdata,
  searchdata,
  proDdata,
  madedata,
  hsndata,
  materialdata = undefined,
  setCategorydata,
  setIsLoadingc = undefined,
  isLoadingc = undefined,
  SetIsLoadingTableData = undefined,
  setProgress = undefined,
  setColordata,
  isLoadingcolor,
  setIsLoadingcolor,
  setFinishData,
  isLoadingfin,
  setIsLoadingfin,
  setHsndata,
  isLoadinghsn,
  setIsLoadinghsn,
  //selectedstates
  selectedCategory,
  selectedProductType,
  selectedColor,
  selectedpron,
  selectedsku,
  selectedBuyer,
  selectedFinish,
  selectedAlias,
  selectedSearch,
  selectedpd,
  selectedmade,
  selectedhsn,
  selectedmaterial,
  selectedDateRange,
  selectedUpdatedDateRange,
  //onchangehandlers
  handleCategoryChange,
  handleProductTypeChange,
  handleColorChange,
  handleProNameChange,
  handleSkuChange,
  handleBuyerChange,
  handleFinishChange,
  handleAliasChange,
  handleSearchChange,
  handleProDChange,
  handleMadeChange,
  handleHSNChange,
  handleMaterialChange,
}) => {
  const AddedOn = [
    'Today',
    'Yesterday',
    'This week',
    'Last week',
    'This month',
    'Last month',
    'Last 3 month',
    'Last 6 month'
  ].map(item => ({ label: item, value: item }));

  return (
    <Stack spacing={2}>
      {head.some(item => item.FilterName === 'Category' && item.filterstatus == true) && (
        <div id="custom-container" style={{ position: 'relative' }}>
          <CheckPicker
            data={categorydata}
            placeholder={`${label[0]?.attributes.Category}`}
            value={selectedCategory}
            onChange={handleCategoryChange}
            style={{ width: 125 }}
            // onOpen={() => fetchCategory( setCategorydata, setIsLoadingc, isLoadingc, SetIsLoadingTableData, setProgress)}
            menuStyle={{ maxWidth: 250, zIndex: 999999 }}
            container={() => document.body}
          />
        </div>
      )}
      {head.some(item => item.FilterName === 'ProductType' && item.filterstatus == true) && (
        <div id="custom-container" style={{ position: 'relative' }}>
          <CheckPicker
            data={productypedata}
            placeholder={`${label[0]?.attributes.ProductType}`}
            value={selectedProductType}
            onChange={handleProductTypeChange}
            style={{ width: 135 }}
            menuStyle={{ maxWidth: 250, zIndex: 999999 }}
            container={() => document.body}
          />
        </div>
      )}
      {head.some(item => item.FilterName === 'Color' && item.filterstatus == true) && (
        <div id="custom-container" style={{ position: 'relative' }}>
          <CheckPicker
            data={colordata}
            placeholder={` ${label[0]?.attributes.color}`}
            value={selectedColor}
            onChange={handleColorChange}
            style={{ width: 125 }}
            // onOpen={fetchColors(setColordata,isLoadingcolor,setIsLoadingcolor)}
            menuStyle={{ maxWidth: 250, zIndex: 999999 }}
            container={() => document.body}
          />
        </div>
      )}
      {head.some(item => item.FilterName === 'ProName' && item.filterstatus == true) && (
        <div id="custom-container" style={{ position: 'relative' }}>
          <CheckPicker
            value={selectedpron}
            onChange={handleProNameChange}
            data={proNamedata}
            placeholder={`${label[0]?.attributes.ProductName}`}
            style={{ width: 135 }}
            menuStyle={{ maxWidth: 250, zIndex: 999999 }}
            container={() => document.body}
          />
        </div>
      )}
      {head.some(item => item.FilterName === 'Finish' && item.filterstatus == true) && (
        <div id="custom-container" style={{ position: 'relative' }}>
          <CheckPicker
            value={selectedFinish}
            onChange={handleFinishChange}
            data={finishdata}
            placeholder={`${label[0]?.attributes.finish}`}
            style={{ width: 135 }}
            onOpen={() => fetchFinishes(setFinishData, isLoadingfin, setIsLoadingfin)}
            menuStyle={{ maxWidth: 250, zIndex: 999999 }}
            container={() => document.body}
          />
        </div>
      )}
      {head.some(item => item.FilterName === 'AliasCode' && item.filterstatus == true) && (
        <div id="custom-container" style={{ position: 'relative' }}>
          <CheckPicker
            data={aliasdata}
            placeholder={`${label[0]?.attributes.AliasCode}`}
            value={selectedAlias}
            onChange={handleAliasChange}
            style={{ width: 135 }}
            menuStyle={{ maxWidth: 250, zIndex: 999999 }}
            container={() => document.body}
          />
        </div>
      )}
      {head.some(item => item.FilterName === 'SearchK' && item.filterstatus == true) && (
        <div id="custom-container" style={{ position: 'relative' }}>
          <CheckPicker
            value={selectedSearch}
            onChange={handleSearchChange}
            data={searchdata}
            placeholder={`${label[0]?.attributes.searchKeyword}`}
            style={{ width: 135 }}
            menuStyle={{ maxWidth: 250, zIndex: 999999 }}
            container={() => document.body}
          />
        </div>
      )}
      {head.some(item => item.FilterName === 'PDesign' && item.filterstatus == true) && (
        <div id="custom-container" style={{ position: 'relative' }}>
          <CheckPicker
            value={selectedpd}
            onChange={handleProDChange}
            data={proDdata}
            placeholder={` ${label[0]?.attributes.ProductDesigner}`}
            style={{ width: 135 }}
            menuStyle={{ maxWidth: 250, zIndex: 999999 }}
            container={() => document.body}
          />
        </div>
      )}
      {head.some(item => item.FilterName === 'MadeBy' && item.filterstatus == true) && (
        <div id="custom-container" style={{ position: 'relative' }}>
          <CheckPicker
            value={selectedmade}
            onChange={handleMadeChange}
            data={madedata}
            placeholder={`${label[0]?.attributes.MadeBy}`}
            style={{ width: 135 }}
            menuStyle={{ maxWidth: 250, zIndex: 999999 }}
            container={() => document.body}
          />
        </div>
      )}
      {head.some(item => item.FilterName === 'HSN' && item.filterstatus == true) && (
        <div id="custom-container" style={{ position: 'relative' }}>
          <CheckPicker
            value={selectedhsn}
            onChange={handleHSNChange}
            data={hsndata}
            placeholder={` ${label[0]?.attributes.HSN}`}
            style={{ width: 135 }}
            onOpen={() => fetchHsn(setHsndata, isLoadinghsn, setIsLoadinghsn)}
            menuStyle={{ maxWidth: 250, zIndex: 999999 }}
            container={() => document.body}
          />
        </div>
      )}
      {head.some(item => item.FilterName === 'BuyerName' && item.filterstatus == true) && (
        <div id="custom-container" style={{ position: 'relative' }}>
          <CheckPicker
            value={selectedBuyer}
            onChange={handleBuyerChange}
            data={buyernamedata}
            placeholder={`${label[0]?.attributes.BuyerName}`}
            style={{ width: 135 }}
            menuStyle={{ maxWidth: 250, zIndex: 999999 }}
            container={() => document.body}
          />
        </div>
      )}
      {head.some(item => item.FilterName === 'BuyerStyle' && item.filterstatus == true) && (
        <div id="custom-container" style={{ position: 'relative' }}>
          <CheckPicker
            value={selectedsku}
            onChange={handleSkuChange}
            data={skudata}
            placeholder={`${label[0]?.attributes.BuyerSku}`}
            style={{ width: 145 }}
            menuStyle={{ maxWidth: 250, zIndex: 999999 }}
            container={() => document.body}
          />
        </div>
      )}
      {head.some(item => item.FilterName === 'MaterialName' && item.filterstatus == true) && (
        <div id="custom-container" style={{ position: 'relative' }}>
          <CheckPicker
            value={selectedmaterial}
            onChange={handleMaterialChange}
            data={materialdata}
            placeholder={`${label[0]?.attributes.MaterialName}`}
            style={{ width: 145 }}
            menuStyle={{ maxWidth: 250, zIndex: 999999 }}
            container={() => document.body}
          />
        </div>
      )}
      {head.some(item => item.FilterName === "CreateOn" && item.filterstatus == true) && (
        <div id="custom-container" style={{ position: 'relative' }}>
          <SelectPicker
            data={AddedOn}
            size="md"
            appearance="default"
            placeholder="Added On"
            style={{ width: 145 }}
            value={selectedDateRange}
            menuStyle={{ maxWidth: 250, zIndex: 999999 }}
            container={() => document.body}
          />
        </div>
      )}
      {head.some(item => item.FilterName === "UpdateOn" && item.filterstatus == true) && (
        <div id="custom-container" style={{ position: 'relative' }}>
          <SelectPicker
            data={AddedOn}
            size="md"
            appearance="default"
            placeholder="Updated On"
            style={{ width: 145 }}
            value={selectedUpdatedDateRange}
            menuStyle={{ maxWidth: 250, zIndex: 999999 }}
            container={() => document.body}
          />
        </div>
      )}
    </Stack>
  );
};

export default HeaderFilter;
